export default __webpack_public_path__ + "static/IBMPlexSans-TextItalic-Cyrillic-5b718446843719fea4f5e3a54fb2bbfd.woff2";